export default function Logo() {
    return (
        <img className="w-[40px]" src="./renteasy.png" alt="" />
    )
    
}